<template>
  <scrollable
    v-show="show || (useBottomAction && !isOne)"
    :xs="!useBottomAction"
    :action="useBottomAction"
  >
    <payment-btn
      v-for="(item, index) in items"
      :key="index"
      :class="useBottomAction ? 'mb-3' : 'mb-1'"
      :title="$t(item.title)"
      :name="$t(item.title)"
      :color="item.color"
      :logo="item.img"
      class="half-bloc"
      @click="action(item)"
    />

    <scan-choice-dialog
      v-model="menuDialog"
      @action="action()"
      @hide="hideModal"
    />

    <bottom-action
      v-if="useBottomAction"
      btn-cancel
      btn-valid-disabled
      @del="actionDel"
      @cancel="actionCancel"
    />
  </scrollable>
</template>

<script>
import { ActionEnum, CategoryEnum } from '@/modules/Enums'
import { $alert } from '@/modules/Utils'
import ScanChoiceDialog from './modal/ScanChoiceDialog'
import { dpaPayment } from '@/modules/Operations'

export default {
  name: 'ActionChoice',

  components: {
    ScanChoiceDialog
  },

  model: {
    prop: 'show',
    event: 'change'
  },

  props: {
    show: { type: Boolean, default: true },
    useBottomAction: { type: Boolean, default: false },
    fromAchat: { type: Boolean, default: false },
    toGift: { type: Boolean, default: false },
    toGiftReset: { type: Boolean, default: false },
    toCashlessReset: { type: Boolean, default: false },
    toCredit: { type: Boolean, default: false },
    toBI: { type: Boolean, default: false },
    xs: { type: Boolean, default: false }
  },

  data () {
    return {
      items: [],
      savedItems: null,
      isOne: false,
      isFirstBack: true,
      isSecondClick: false,
      //
      currentItem: null,
      menuDialog: false
    }
  },

  computed: {
    settings () { return this.$store.state.teleparameters },
    actionItems () { return this.$store.state.actionItems },
    favoriteScan () { return this.$store.getters.favoriteScan },
    merchantName () { return this.$store.state.merchantName },
    useBanking () { return this.$store.getters.useBanking }
  },

  watch: {
    show (val) {
      if (val === false) {
        this.items = this.actionItems
        this.$emit('title', this.merchantName)
      } else {
        this.checkItems()
      }
    }
  },

  mounted () {
    if (this.toBI) {
      this.action({
        display: 'button.shortcut_badge',
        catcode: CategoryEnum.cashless,
        action: ActionEnum.badgeInformations
      })
    } else if (this.toGift) {
      this.action({
        display: 'button.shortcut_gift',
        catcode: CategoryEnum.gift,
        action: ActionEnum.gift
      })
    } else if (this.toCashlessReset) {
      this.action({
        display: 'button.shortcut_reinit',
        catcode: CategoryEnum.cashless,
        action: ActionEnum.cashlessReset
      })
    } else if (this.toGiftReset) {
      this.action({
        display: 'button.shortcut_gift_reset',
        catcode: CategoryEnum.gift,
        action: ActionEnum.giftReset
      })
    } else if (this.toCredit) {
      this.action({
        display: 'title.parameters_lot_credit',
        catcode: CategoryEnum.giftCredit,
        action: ActionEnum.giftCredit
      })
    } else if (this.actionItems === null) {
      this.$router.replace('/')
    } else {
      this.items = this.actionItems
      this.checkItems()
    }
  },

  methods: {
    checkItems () {
      if (this.items.length === 0) {
        $alert('Aucune action disponible')
        this.$router.replace({ name: 'home', params: { reset: false } })
      } else if (this.useBottomAction && this.items.length === 1) {
        this.isOne = true
        this.action(this.items[0])
      } else {
        this.$emit('title', this.$i18n.t(this.items[0].category))
      }
    },
    actionCancel () {
      this.$router.replace('/home')
    },
    hideModal () {
      if (this.isOne || this.items.length === 0) {
        this.$router.replace({ name: 'home', params: { reset: false } })
      } else {
        this.menuDialog = false
      }
    },
    actionDel () {
      if (this.savedItems !== null && !this.isSecondClick) {
        this.items = this.isFirstBack ? this.savedItems : this.actionItems
        this.isFirstBack = !this.isFirstBack
        this.isSecondClick = true
        this.$emit('title', this.$i18n.t(this.items[0].category))
      } else {
        this.$router.replace({ name: 'home', params: { reset: false } })
      }
    },
    action (item = this.currentItem) {
      if (item.items) {
        this.$emit('title', this.$i18n.t(item.title))
        this.isSecondClick = false
        this.savedItems = this.items
        this.items = item.items
        // Si un seul item, on execute l'action
        if (this.items.length === 1) {
          this.action(this.items[0])
        }
        return
      }

      let name = ''
      let mode = 'P'
      let isCashlessCb = false
      switch (item.catcode) {
        case CategoryEnum.gift:
        case CategoryEnum.cashless:
        case CategoryEnum.loyalty:
        case CategoryEnum.giftCredit:

          // Set cashless reload mode
          if (item.action === ActionEnum.cashlessCredit) {
            isCashlessCb = item.mode === '1'
            mode = item.mode
          }

          // Set scan view
          if (this.$store.state.offline) {
            name = 'scan-nfc-offline'
          } else {
            // Get favorite scanner
            if (this.favoriteScan === null) {
              this.currentItem = item
              this.menuDialog = true
              return
            }
            name = this.favoriteScan
          }

          break
        case CategoryEnum.lyfpay:
          // Set scan view
          name = 'scan-qrcode'
          break
        case CategoryEnum.banking:
          if (item.action === ActionEnum.dpa) {
            // Call to DPA
            dpaPayment((error) => {
              $alert(error)
            })
          } else {
            // Go to cb app
            this.$router.replace({
              name: 'banking-payment',
              params: {
                goToCashless: isCashlessCb
              }
            })
          }
          return
        default:
          $alert(this.$i18n.t('error.no_action'))
          this.$router.replace('home')
          return
      }

      // Set title view
      this.$emit('title', this.$i18n.t(item.display, { type: this.$i18n.t(item.title) }))

      // Si on a accès à une appli bancaire, on redirige
      if (isCashlessCb && this.useBanking) {
        this.$router.replace({
          name: 'banking-payment',
          params: {
            goToCashless: isCashlessCb
          }
        })
      } else {
        // Sinon, on redirige vers la route prédéfinie
        this.$router.replace({
          name: name,
          params: {
            action: item.action,
            mode: mode,
            fromAchat: this.fromAchat,
            backToHome: (
              this.isOne || !this.useBottomAction ||
              item.action === ActionEnum.badgeInformations ||
              item.action === ActionEnum.gift ||
              item.action === ActionEnum.giftReset
            )
          }
        })
      }
    }
  }
}
</script>
